import React from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import CssBaseline from '@material-ui/core/CssBaseline';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import bg from '../../static/images/bg.jpg';

const useStyles = makeStyles(() => ({
    bg: {
        position: "relative",
        backgroundImage: "linear-gradient(rgba(245, 222, 179, 0.3), rgba(76, 142, 203, 0.6)), url(" + bg + ")",
        backgroundAttachment: "fixed",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat"
    },
    root: {
        minHeight: "100vh",
        paddingTop: "65px",
        position: "relative"
    },
    st0: { 
        fill: "white",
        
    },
    st1: {
        opacity:"0.8",
        fill:"#4c8ecb"
    }
}))

export default function Header(props) {
    const classes = useStyles();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up("sm"));
    const sz = () => {
        if(matches) {
            return "100vh";
        }

        return "95vh";
    }

    const pT = () => {
        if(matches) {
            return "65px";
        }

        return "15px";
    }

    return (
        <>
            <CssBaseline />
            {props.children &&
                <Container className={classes.bg}>
                    <svg version="1.1" id="Layer_2" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                        viewBox="0 0 1920 1080" style={{ position: "absolute", bottom: "-1", left: "0" }} xmlSpace="preserve">
                        <path className={classes.st1} d="M1092,998c-252.19,173.32-315-37-570-95c-117.97-26.83-201.43,69.9-342,71C52,975-1,1080-1,1080h1920
	c0,0,0-218,1-256c-81,250-346-28-556,118C1247.81,1022.78,1181.68,936.37,1092,998z"/>
                    </svg>
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                        viewBox="0 0 1920 1080" style={{ position: "absolute", bottom: "-1", left: "0" }} xmlSpace="preserve">
                        <path className={classes.st0} d="M-0.5,1080c0,0,196-61,310-47c155.51,19.1,164-107,564.44,26.46c41.99,14,87.89,10.43,129.59-4.42
	c226.12-80.51,296.05-1.65,376.97-20.05c67.12-15.25,114.24-92.31,247.14-92.31c182.5,0,269.86-9.69,292.36-73.69v211H-0.5z"/>
                    </svg>
                    <Grid 
                    container 
                    justify="center" 
                    alignItems="center" 
                    className={classes.root}
                    style={{minHeight: sz(), paddingTop: pT()}}
                    >
                        <Grid item xs={12} md={6}>
                            <Grid container spacing={2}>
                                <Grid item md={8} xs={12}>
                                    {props.children}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Container>
            }
        </>
    )
}